/* @sravni/react-design-system version 0.2.55 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles, error, isNull } from '@sravni/react-utils';
import '../../Space/index.js';
import modules_ff399ec7 from '../styles/ControlGroup.module.less.js';
import Space from '../../Space/src/Space.js';

/**
 * @description ControlGroup component.
 *
 * @component
 * @example
 * ```jsx
 * <ControlGroup>
 *  <TextInput placeholder="Left input position"/>
 *  <TextInput placeholder="Center input position"/>
 *  <TextInput placeholder="Right input position"/>
 * </ControlGroup>
 * ```
 */
var ControlGroup = React.forwardRef(function (props, ref) {
    var className = props.className, children = props.children, direction = props.direction, restProps = __rest(props, ["className", "children", "direction"]);
    var cx = useStyles(modules_ff399ec7);
    var count = React.useMemo(function () { return React.Children.count(children); }, [children]);
    var condition = count < 2;
    // Ensure group has more than one child node
    if (condition) {
        error({
            condition: condition,
            message: 'Ensure group has more than one child node',
        })();
    }
    var group = React.useMemo(function () {
        return React.Children.map(children, function (child, index) {
            if (isNull(child)) {
                return;
            }
            if (condition) {
                return child;
            }
            var positionInGroup;
            if (index === 0) {
                positionInGroup = 'start';
            }
            else if (index === count - 1) {
                positionInGroup = 'end';
            }
            else {
                positionInGroup = 'middle';
            }
            return React.cloneElement(child, __assign(__assign({}, child.props), { positionInGroup: positionInGroup, directionGroup: direction }));
        });
    }, [children]);
    return (React.createElement("div", __assign({ ref: ref, "data-qa": "ControlGroup", className: cx(className, 'container') }, restProps),
        React.createElement(Space, { direction: direction, size: 2 }, group)));
});
ControlGroup.defaultProps = {
    direction: 'horizontal',
};

export default ControlGroup;
//# sourceMappingURL=ControlGroup.js.map
